// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1_3Wm","label":"Section_label__Efmux","contentWrap":"Section_contentWrap__3OErI","footer":"Section_footer__D8N91","footerInner":"Section_footerInner__1V5m-"};